<ion-app>
  <app-side-menu></app-side-menu>
</ion-app>
